import { __extends } from "tslib";
import { GetFaceSearchRequest, GetFaceSearchResponse } from "../models/index";
import { deserializeAws_json1_1GetFaceSearchCommand, serializeAws_json1_1GetFaceSearchCommand, } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var GetFaceSearchCommand = /** @class */ (function (_super) {
    __extends(GetFaceSearchCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetFaceSearchCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    GetFaceSearchCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: GetFaceSearchRequest.filterSensitiveLog,
            outputFilterSensitiveLog: GetFaceSearchResponse.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetFaceSearchCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1GetFaceSearchCommand(input, context);
    };
    GetFaceSearchCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1GetFaceSearchCommand(output, context);
    };
    return GetFaceSearchCommand;
}($Command));
export { GetFaceSearchCommand };
//# sourceMappingURL=GetFaceSearchCommand.js.map